import Axios from '../axios-instance';

export const PaymentOrdersAPI = {
  getPaymentOrders: request => {
    return Axios.post('/PayOrders/Get', request).then(({ data }) => data);
  },
  getFile: url => {
    return Axios.get(`/PayOrders/GetFile/${btoa(url)}`).then(({ data }) => data);
  },
};
